module.exports = __webpack_public_path__ + "assets/img/slot_empty.493a7ff5.png";